import type { TableProps, ColumnType as Columns } from 'antd/es/table';
import React from 'react';
import { Table as AntdTable } from 'antd';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Table: React.FC<TableProps<any>> = props => {
  return (
    <AntdTable {...props} />
  );
};


export default Table;
export type ColumnType<T> = Columns<T>;